import React from 'react'
import SearchResultPage from '../../../react4xp/components/SearchResultPage'

function SearchResultPagePart({heading, info, pagination, startValues, strings, solutions, documentationTypes, articlesTypes}) {
  return <SearchResultPage title={heading} documentationHelperText={info} endpoint={pagination.endpoint} strings={strings} solutions={solutions} documentationTypes={documentationTypes} articlesTypes={articlesTypes} />
}

export default (props) => <SearchResultPagePart {...props} />
